import FormField from "../form-field";
import SocialInput from "../components/socials-input";

export default class SocialsField extends FormField {
    constructor(props = {}) {
        super(props);
    }

    _afterInit() {
        this.socialsInput = new SocialInput({
            $root: this.$input,
            subscriptions: [{
                event: 'valueChange',
                callback: this._handleValueChange.bind(this)
            }]
        });
    }

    _handleValueChange(value) {
        this.controller.setValue(value);
        this._setStatus(this.controller.valid ? 'valid' : 'neutral');
    }

    _refresh() {
        this.socialsInput.dropState();
    }
}